<!--
 * @Author: xiaokun
 * @Date: 2020-04-11 14:46:12
 * @LastEditors: xiaokun
 * @LastEditTime: 2020-04-23 10:46:16
 * @Description: 题目导入库（从话术库导入） - 使用 mk-biz 重构版话术库
 -->
<template>
  <mk-drawer
    :visible="visible"
    size="1210px"
    hide-header
    class="guide-question-drawer"
    @close="handleOnDrawerCloseClick"
  >
    <!-- header 头部区域 -->
    <div class="guide-question-drawer-header">
      <div class="guide-question-drawer-header-content">
        <div class="guide-question-drawer-title-content">
          <div class="question-title">
            问题库分类
          </div>
          <div class="divider-line" />
          <div class="all-question">
            全部问题
          </div>
        </div>
      </div>
      <!-- 关闭icon -->
      <ds-iconfont
        icon-class="icon-mk-guanbi"
        class="close cursor"
        @click.native="handleOnDrawerCloseClick"
      />
    </div>

    <!-- 中间区域 -->
    <!-- 左侧树形结构 -->
    <div class="guide-question-drawer-content">
      <div class="guide-question-content-left">
        <left-tree @node-click="onNodeClick" />
      </div>
      <div class="question-divider-line" />
      <!-- 右侧biz列表 -->
      <div class="guide-question-content-right">
        <right-question-table
          ref="GuideQuestionContentRightTable"
          :choose-question-list="chooseQuestionList"
          @on-select-question="getSelectQustionList"
          @on-drawer-close-click="handleOnDrawerCloseClick"
        />
      </div>
    </div>
  </mk-drawer>
</template>
<script>
import LeftTree from './left-tree'
import RightQuestionTable from './right-question-table'
import { mapMutations, mapState } from 'vuex'
export default {
  name: '',
  components: { LeftTree, RightQuestionTable },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    chooseQuestionList: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      // 左侧树形结构所需接口
      treeApis: {
        get: CONVERSATIONAPIS.QuestionsApi.pQuestionTreeGet
      },
      // 面包屑
      crumbData: []
    }
  },
  computed: {
    // 树形结构当前id
    currentMenuId () {
      return this.$store.state['examination-manage'].currentMenuId
    }
  },
  methods: {
    // 存入当前选中树id
    ...mapMutations('examination-manage', {
      setCurrentMenuId: 'SET_CURRENTMENUID'
    }),
    handleBeforeClose () {
    },
    // 关闭弹窗事件
    handleOnDrawerCloseClick () {
      this.setCurrentMenuId('const-question-tree-root-id')
      this.$emit('on-close-drawer')
      // 清空弹窗所选
      this.clearSelection()
      // 重置弹窗首页
      this.$refs.GuideQuestionContentRightTable.handleOnResetClick()
    },
    // 清除所选
    clearSelection () {
      // 加判断是为了避免 编辑时一进入 节点未打开过调用删除失败
      if (this.$refs.GuideQuestionContentRightTable) {
        this.$refs.GuideQuestionContentRightTable.clearSelection()
      }
    },
    // 树形节点被点击时候搜索问题
    onNodeClick (data) {
      let { level, _id } = data
      if (this.currentMenuId === _id) return
      // 将左侧树 id 值存入vuex
      this.setCurrentMenuId(_id)

      this.crumbData = data.treeSource ? data.treeSource : []
      // 调用右侧 表格数据切换
      this.$refs.GuideQuestionContentRightTable.initParams()
    },
    // 获取 导入数据
    getSelectQustionList (val) {
      this.$emit('on-select-question', val)
    }
    // 返回右侧面包屑
    // getCrumb (data) {
    //   let { level, _id } = data
    // }
  }
}
</script>
<style lang='scss' scoped>
.guide-question-drawer {
  & /deep/ .el-drawer__body {
    display: flex;
    flex-direction: column;
    height: 100%;

    // 头部
    .guide-question-drawer-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: #262626;
      font-size: 14px;
      height: 55px;
      padding: 0 22px;
      border-radius: 2px 2px 0 0;
      flex-shrink: 0;
      border-bottom: 1px solid #e8e8e8;

      .guide-question-drawer-title-content {
        display: flex;
        align-items: center;

        .question-title,
        .all-question {
          font-weight: 500;
        }

        .question-title {
          width: 242px;
        }

        .all-question {
          padding-left: 20px;
        }

        .divider-line {
          display: inline-block;
          width: 1px;
          height: 60px;
          background-color: #e8e8e8;
        }
      }

      .close {
        font-size: 14px;
        color: #bfbfbf;
      }
    }

    // 内容
    .guide-question-drawer-content {
      display: flex;
      height: 100%;

      // 左侧树形结构
      .guide-question-content-left {
        width: 258px;
        padding-left: 6px;
        overflow-y: scroll;
      }

      .question-divider-line {
        display: inline-block;
        width: 1px;
        height: 100%;
        background-color: #e8e8e8;
      }

      .guide-question-content-right {
        width: 945px;
        height: 100%;
      }
    }
  }
}

</style>
